/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './data-export-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-data-export-list-page',
  template
})
export class DataExportListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.data-exports.data-export';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type', label: 'exportType'},
    {param: 'source', label: 'fieldsSource'},
    {param: 'data', label: 'dataForExport'},
    {param: 'format'},
    {param: 'schedule'},
    {param: 'compression'},
    {param: '', label: 'fields', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }

  shouldShowSimpleDash(item: any): boolean {
    return item?.type === 'PLATFORM_161';
  }

  shouldHideDataSpecificValues(item: any): boolean {
    return this.shouldShowSimpleDash(item) || item?.source === 'RAW_LOG' || item?.source === 'STATS';
  }
}
